// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__VXcwj","errorLogs":"EditorFooter_errorLogs__UgxeF"};